export const SEARCH_TYPES = {
    ICONS: "icons",
    ICON_COLLECTIONS: "icon-collections",
    PHOTOS: "photos"
};
